import { Box } from "@mui/material";
import { HeroSectionComponent } from "../components/HeroSectionComponent";
import ServiceImage from "../assets/industriesHero.webp";
import { textlanguages } from "../data/textOfThePage";
import { useLanguageContext } from "../context/languageContext";
import { capitalizeFirstLetter } from "../helpers/capitalizeFirstLetter";
import IndustriesSection from "../components/landing/section-industries/IndustriesSection";

export const IndustriesPage = () => {
  const { languageSelected } = useLanguageContext();
  const serviceText = textlanguages[languageSelected].header[1].service;
  return (
    <Box>
      <HeroSectionComponent
        image={ServiceImage}
        text={capitalizeFirstLetter(serviceText)}
      />
      <IndustriesSection />
    </Box>
  );
};
